import { ArrowRight, MapPin } from "lucide-react";

const HERO_BG =
  "https://images.pexels.com/photos/36361391/pexels-photo-36361391.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1080&w=1920";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[95vh] flex items-end overflow-hidden bg-[#0A0A0A]"
    >
      <img
        src={HERO_BG}
        alt="Südhessen Architektur"
        className="absolute inset-0 w-full h-full object-cover opacity-55"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/65 to-black/40" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-black/20" />

      <div className="relative w-full max-w-7xl mx-auto px-6 lg:px-10 pb-20 lg:pb-28 pt-32">
        <div className="max-w-4xl fade-up">
          <div className="flex items-center gap-3 mb-8">
            <span className="h-px w-12 bg-[#8A151B]" />
            <span className="text-xs uppercase tracking-[0.3em] font-bold text-[#8A151B]">
              Rosenberg Objektservice · Südhessen
            </span>
          </div>

          <h1
            data-testid="hero-headline"
            className="font-display font-black uppercase text-white leading-[0.95] tracking-tighter text-5xl sm:text-6xl lg:text-8xl"
          >
            Ihr Makler,
            <br />
            der <span className="text-[#8A151B]">mit anpackt.</span>
          </h1>

          <p className="mt-8 text-lg sm:text-xl text-neutral-300 max-w-2xl leading-relaxed">
            Vermittlung, Betreuung, Reparatur und Pflege — aus einer Hand.
            Kein anonymes Maklerbüro, sondern ein Partner, der weiß, wo
            angepackt werden muss.
          </p>

          <div className="mt-12 flex flex-col sm:flex-row gap-4">
            <a
              href="#kontakt"
              data-testid="hero-cta-primary"
              className="group inline-flex items-center justify-center gap-3 bg-[#8A151B] text-white hover:bg-[#6B1015] px-8 py-4 font-semibold tracking-wide transition-all duration-300 uppercase text-sm"
            >
              Unverbindlich anfragen
              <ArrowRight
                size={18}
                className="group-hover:translate-x-1 transition-transform"
              />
            </a>
            <a
              href="#leistungen"
              data-testid="hero-cta-secondary"
              className="inline-flex items-center justify-center gap-2 bg-transparent border border-white/40 text-white hover:bg-white hover:text-[#0A0A0A] px-8 py-4 font-semibold tracking-wide transition-all duration-300 uppercase text-sm"
            >
              Leistungen ansehen
            </a>
          </div>

          <div className="mt-16 flex flex-wrap items-center gap-x-10 gap-y-4 text-neutral-400">
            <div className="flex items-center gap-2">
              <MapPin size={16} className="text-[#8A151B]" />
              <span className="text-sm uppercase tracking-wider">
                Region Südhessen
              </span>
            </div>
            <span className="hidden sm:block h-4 w-px bg-neutral-700" />
            <span className="text-sm uppercase tracking-wider">
              Persönlich · Verlässlich · Handwerklich
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
